import { ConfirmationData } from "../../../../common/summary-common/confirmationData";


export const overWriteFamilyMedicalHistoryInformation: Map<string, ConfirmationData> = new Map([
    ["8ed02457-4958-4992-b1d0-0529f4623a68|0f775e48-c1f9-4249-8f3c-bdc40c9f4718", { hidden: true }],
    ["1e2256ee-aa56-4a1f-b6d4-bb35668179c0|e1b20b24-9aeb-49cd-9288-adb444a17f71", { hidden: true }],
]);



